import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHttpClient } from '../../../../shared/http-client';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { ItvTabForm } from './itv-tab-form';




export const ItvTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const { t } = useTranslation() as { t: (key: string) => string };
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [refresh, setRefresh] = useState<string | null>(null);

    // Load initial data
    useEffect(() => {
        if (item) {
            api(`/fleet/vehicles/${item}/`, 'GET');
        }
    }, [item]);


    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };

    const handleNewAction = () => {
        open('common.form-title.new', <ItvTabForm close={handleClose} vehicleId={item} />);
    };


    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('fleet/vehicles')) {
                /* if (state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    window.location.reload();

                } */
                if (state.method === 'GET') {
                    setData(state.data)

                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }
        }
    }, [state]);



    return (
        <>

            <PageBody
                newAction={handleNewAction}
                newActionTitle={'common.form-title.new'}
                title={'common.label.itv'}
            //titleStatus={'OK'}

            >
                <div>
                    <Table
                        path={`/fleet/inspections/?vehicle=${item}&`}
                        deletePath={`/fleet/inspections/`}
                        callBeforeDrawerClosed={handleClose}
                        Form={ItvTabForm}
                        withPagination
                        refresh={refresh}
                        headers={[
                            {
                                key: 'center',
                                subKey: 'name',
                                label: 'common.label.centro',
                            },
                            {
                                key: 'cost',
                                label: 'common.label.costo',
                            },
                            {
                                key: 'observations',
                                label: 'common.label.observaciones',
                            },
                            {
                                key: 'mileage',
                                label: 'common.label.kilometraje',
                            },
                            {
                                key: 'date',
                                type: 'date',
                                label: 'common.labels.date',
                            },
                            {
                                key: 'next_date',
                                type: 'date',
                                label: 'common.label.fecha-proxima-itv',
                            },
                            {
                                key: 'state',
                                subKey: 'name',
                                label: 'common.label.estado-itv',
                            },
                            {
                                key: 'status',
                                type: 'status',
                                label: 'common.label.estado',
                            },

                        ]}
                    />

                </div>

            </PageBody>
        </>

    );
};